class CarMileageEntry {
  constructor(id, mileage) {
    this.id = id;
    this.mileage = mileage;
  }
}

export default CarMileageEntry;
